// @ts-nocheck
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import Loading from "../../components/Loading";
import { GoChevronDown, GoChevronUp } from "react-icons/go";
import moment from "moment";
import { LiveIcon, CashIcon, NoBuyerIcon,ReportedIcon } from "../../components/Live";
import HotelIcon from "@mui/icons-material/LocalHotelOutlined";
import CottageOutlinedIcon from "@mui/icons-material/CottageOutlined";
import BathtubOutlinedIcon from "@mui/icons-material/BathtubOutlined";
import { Box, IconButton,useMediaQuery } from "@mui/material";
import {
  addFavoriteProperty,
  getFavorityProperty,
  addSelectedId,
  removeSelectedId,
} from "../../redux/slice/favoritePropertySlice";
import { useSelector, useDispatch } from "react-redux";

export const PropertyCard = ({
  item,
  isMobile,
  loading,
  countdowns,
  formatToDollar,
  index,
}) => {

  const isMdOrLarger = useMediaQuery("(min-width:1000px)");
  const [error, setError] = useState(null);
  const [liveIconVisible,setLiveIconVisible] = useState(false)
  const navigate = useNavigate();
  const { investorId } = useSelector((state) => state?.user);
  const { favoriteProperties } = useSelector(
    (state) => state.favoriteProperties
  );

  useEffect(() => {
    const currentDateTime = new Date(); // Get current date and time
    const saleDateTime = moment.parseZone(item.srpSaleDateTime); // Use the sale date time from the property
    
    // Calculate the time remaining in milliseconds
    const auctionStartStr = moment.parseZone(item.srpSaleDateTime).format("YYYY-MM-DDTHH:mm:ssZ");
    const auctionStartDate = new Date(auctionStartStr);
    const timeRemaining = auctionStartDate - currentDateTime; // Time remaining in milliseconds
    
    // If the countdown reaches zero or the sale date is in the past, show the live icon
    if (timeRemaining <= 0) {
      setLiveIconVisible(true);
    } else {
      setLiveIconVisible(false);
    }
  }, [countdowns, item.srpSaleDateTime]);
  ; // Effect will run when countdowns or sale date changes
   // Ensure this effect runs whenever countdowns change

  
  const selectedIndex = useSelector(
    (state) => state.favoriteProperties.selectedIds
  );

  const dispatch = useDispatch();

  const handleViewDetails = (property) => {
    const propertyId = item.propertyId;
    const remoteflag = item.isRemoteBiddingEligible;
    navigate(`/auctionPage/${propertyId}`, { state: { remoteflag } });
  };

  const isValid = (value) => value && value !== "0" && value !== 0;

  const isScheduledForFuture = (saleDate) => {
    const currentDate = moment(); // Current date and time
    const saleDateTime = moment.parseZone(saleDate); // Parse sale date time
    return saleDateTime.isSameOrAfter(currentDate, "day"); // Check if the sale is today or in the future
  };

  const isVisible = isScheduledForFuture(favoriteProperties?.srpSaleDateTime);

  if (!isVisible) return null;

  const handleAddFavoriteProperties = async (propertyId, index) => {
    setError(null);

    const requiredData = {
      investorId,
      propertyId,
      isRemoved: selectedIndex.includes(propertyId), // The toggled value for removal
    };

    console.log(requiredData, "Data");
    try {
      // Dispatch action to add/remove from favorites
      if (selectedIndex.includes(propertyId)) {
        dispatch(removeSelectedId(propertyId));
      } else {
        dispatch(addSelectedId(propertyId));
      }
      await dispatch(addFavoriteProperty(requiredData));
      // Optionally, you may want to handle the updated list in your UI here
      const id = setTimeout(async () => {
        await dispatch(getFavorityProperty(investorId))
      }, 100);
    } catch (error) {
      // Handle any errors
      setError(error);
      console.log(error);
    }
    return () => {
      clearTimeout(id)
    }
  };

  console.log("countdown:-",countdowns)

  return (
    <div data-testid="property-card" className="bg-white flex flex-col gap-y-5 p-2 w-full mb-3 shadow-sm shadow-slate-400/50">
      <Grid container sx={{ width: "100%" }} spacing={{ xs: 1, sm: 2 }}>
        <Grid
          item
          size={{ xs: 4, sm: 3,md:1.7 }}
          style={{
            height: "auto", // Adjust this if you need a fixed height
            position: "relative", // Add this to position the heart icon inside the image container
          }}
        >
          {loading && isScheduledForFuture ? (
            <Loading />
          ) : (
            <div
            className={isMdOrLarger ? "w-[100%]" : ""}
              style={{
                position: "relative",
                height: 140,
                padding: "5px"
                
              }}
            >
              <img
                data-testid="property-image"
                src={item?.imageUrl}
                alt="Property"
                className="w-full h-full object-cover rounded-none" // Use object-cover to maintain aspect ratio
              />
              <IconButton
                onClick={() =>
                  handleAddFavoriteProperties(item.propertyId, index)
                }
                style={{
                  position: "absolute",
                  top: "3px", // Adjust to control distance from the top
                  left: "3px", // Adjust to control distance from the left
                  zIndex: 1, // Ensure the icon stays on top of the image
                  cursor: "pointer",
                }}
                aria-label={"Add to favorites"}
              >
                {/* Conditional rendering of the icon */}
                {!selectedIndex?.includes(item.propertyId) ? (
                  <svg
                    stroke="#ffffff"
                      aria-label="fav-sv-1111"
                    fill="#ffffff"
                    stroke-width="0"
                    viewBox="0 0 1024 1024"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z"></path>
                  </svg>
                ) : (
                  <svg
                    stroke="#ffffff"
                      aria-label="fav-sv-1112"
                    fill="#ffffff"
                    stroke-width="0"
                    viewBox="0 0 1024 1024"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z"></path>
                  </svg>
                )}
              </IconButton>
            </div>
          )}
        </Grid>

        <Grid size={{ xs: 7, sm: "auto" }}>
          <div data-testid="price-section" className="text-lg sm:text-xl">
            <span className="text-[20px] font-semibold leading-[30px]">

            ${item?.openingBidAmount=== null||item?.openingBidAmount=== 0||item?.openingBidAmount===0.00
                                ? (item?.reservePrice>0?formatToDollar(item?.reservePrice):0)
                                : formatToDollar(
                                  item?.openingBidAmount
                                  )}
            </span>
            <span className="text-[14px] font-normal leading-[21px] pl-[7px]">
              Est. Opening Bid
            </span>
          </div>
          <p className="mt-1 sm:mt-2 sm:font-light text-[10px] sm:text-base">
            {item?.isRemoteBiddingEligible === true
              ? "Foreclosure Trustee - Remote bid enabled"
              : "Foreclosure Trustee"}
          </p>
          <p className="mt-1 sm:mt-2 text-sm sm:text-base font-medium text-gray-700">
            {item?.addressLine1} {item?.addressLine2}
          </p>

          {!isMobile && (
            <>
              <div data-testid="property-features" className="flex items-center space-x-2 mt-2">
                {item?.beds !== 0 && (
                  <div className="flex items-center space-x-1">
                    <HotelIcon className="text-gray-600" />
                    <span>{item?.beds} Beds</span>
                  </div>
                )}
                {item?.fullBaths !== 0 && (
                  <div className="flex items-center space-x-1">
                    <BathtubOutlinedIcon className="text-gray-600" />
                    <span>{item?.fullBaths} Baths</span>
                  </div>
                )}
                {item?.sqFt !== 0 && (
                  <div className="flex items-center space-x-1">
                    <CottageOutlinedIcon className="text-gray-600" />
                    <span>{formatToDollar(item?.sqFt)} Sq. Ft.</span>
                  </div>
                )}
              </div>

              <div aria-label="live-icon" className="w-3/5 mt-2">
                {liveIconVisible ? (
                  <div className="w-5/5">
                    <LiveIcon />
                  </div>
                ) : (
                  <>
                    {moment
                      .parseZone(`${item.srpSaleDateTime}`)
                      .format("MMM D, hh:mm A")}
                  </>
                )}
              </div>
            </>
          )}
        </Grid>

        <Grid
          size={{ xs: 12, sm: "auto" }}
          display={"flex"}
          ml={{ sm: "auto" }}
          justifyContent={"space-between"}
          alignItems={{ sm: "flex-end" }}
          rowGap={{ xs: 1 }}
          flexDirection={"column"}
        >
          <div className="flex space-x-3">
          {item?.cashOnlyTag=="Cash Only"?<div aria-label="cash-only-icon"><CashIcon /></div>:""}
          {item?.reportedVacant=="YN_Y"?<div aria-label="reported-vacant-icon"><ReportedIcon /></div>:""}
          </div>
          {isMobile && (
            <div className="flex items-center space-x-2 mt-2">
              {item?.bed !== 0 && (
                <div className="flex items-center space-x-1">
                  <HotelIcon className="text-gray-600" />
                  <span>{item.beds} Beds</span>
                </div>
              )}
              {item?.fullBaths !== 0 && (
                <div className="flex items-center space-x-1">
                  <BathtubOutlinedIcon className="text-gray-600" />
                  <span>{item.fullBaths} Baths</span>
                </div>
              )}
              {item?.sqFt !== 0 && (
                <div className="flex items-center space-x-1">
                  <CottageOutlinedIcon className="text-gray-600" />
                  <span>{item.sqFt} Sq. Ft.</span>
                </div>
              )}
            </div>
          )}

          <div className="flex justify-between">
            {isMobile && (
              <div className="w-3/5 mt-2">
                {liveIconVisible ? (
                  <div className="w-5/5">
                    <LiveIcon />
                  </div>
                ) : (
                  <>
                    {moment
                      .parseZone(`${item.srpSaleDateTime}`)
                      .format("MMM D, hh:mm A")}
                  </>
                )}
              </div>
            )}
            <button
              className="text-white rounded-lg bg-[#FF5C39] px-[16px] py-[10px]"
              onClick={() => handleViewDetails(item)}
              aria-label="View details of the cards"
            >
              View Details
            </button>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};
